import { lazyLoadView } from '@utils/LazyLoad'
import { FEATURES, SEARCH_GROUPS } from '@constants/Text'

export default [
  {
    path: '/tarefas',
    name: 'tarefas',
    meta: {
      can_show: FEATURES.DAILY_TASKS,
      search: {
        title: 'Tarefas do dia',
        description: 'Recomendações diárias de tarefas para o profissional',
        keywords: [
          'tarefas do dia',
          'diárias',
          'recomendações',
          'rotina',
          'checklist',
        ],
        icon: 'calendar-check',
        group: SEARCH_GROUPS.GESTAO_PESSOAS,
      },
    },
    component: () =>
      lazyLoadView(import('@src/modules/daily_tasks/views/daily-tasks')),
  },
]
